const TUIConversation = {
  "发起单聊": "New one-to-one chat",
  "发起群聊": "New group chat",
  "请输入userID": "Enter a user ID",
  "删除会话": "Delete conversation",
  "系统通知": "System notification",
  "置顶会话": "Top conversation",
  "取消置顶": "cancel top conversation",
  "消息免打扰": "Message not disturb",
  "取消免打扰": "cancel not disturb",
  "有人@我": "Someone @ me",
  "@所有人": "@All",
  "条": "strip",
  "我": "me",
  "网络异常，请您检查网络设置": "Network exception, please check the network settings"
}

export default TUIConversation;
